export const getAllOpportunities = state =>
  state.opportunities && state.opportunities.opportunities;
